<template>
  <transition name="fade-slide">
    <div v-if="visible" class="snackbar-container">
      <div class="snackbar-card">
        <img src="../assets/request-success.png" class="snackbar-icon" alt="Icon" />
        <h2 class="snackbar-title">Вопрос отправлен</h2>
        <p class="snackbar-subtitle">Спасибо за ваш вопрос. Консультант ответит вам в чате.</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from "vue";

const visible = ref(true);

onMounted(() => {
  setTimeout(() => {
    visible.value = false;
  }, 3000);
});
</script>

<style scoped>
.snackbar-container {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
}

.snackbar-card {
  background: white;
  color: #333;
  padding: 32px;
  border-radius: 20px;
  width: 100%;
  max-width: 460px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  font-family: "Eastman-Regular", sans-serif;
  transition: background-color 0.3s ease, color 0.3s ease;
}

html[data-theme="dark"] .snackbar-card {
  background: #1e1e1e;
  color: #f0f0f0;
}

.snackbar-icon {
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
}

.snackbar-title {
  font-family: "Eastman-Bold", sans-serif;
  font-size: 20px;
  margin: 0;
  margin-bottom: 10px;
}

.snackbar-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

html[data-theme="dark"] .snackbar-subtitle {
  color: #aaa;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

</style>